/** Conteúdo de um arquivo escolhido pela pessoa, em base64 (envio em JSON para a API). */
export async function fileToBase64(f: Blob): Promise<string> {
  const buf = new Uint8Array(await f.arrayBuffer());
  let s = '';
  for (let i = 0; i < buf.length; i += 0x8000) s += String.fromCharCode(...buf.subarray(i, i + 0x8000));
  return btoa(s);
}

/** Tamanho legível (KB/MB, com vírgula). */
export function fileSize(bytes: number): string {
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1).replace('.', ',')} MB`;
}

/**
 * Foto de perfil: recorta o centro em quadrado e reduz para `size` px (JPEG), no navegador. Aceita o que o navegador
 * consegue abrir (PNG, JPEG, WEBP, HEIC no Safari...); devolve o base64 para a API.
 */
export async function squarePhotoBase64(src: Blob, size = 256): Promise<string> {
  let img: ImageBitmap;
  try {
    img = await createImageBitmap(src);
  } catch {
    throw new Error('Não foi possível abrir a imagem. Use uma foto PNG, JPEG ou WEBP.');
  }
  const side = Math.min(img.width, img.height);
  const canvas = document.createElement('canvas');
  canvas.width = canvas.height = Math.min(size, side);
  const ctx = canvas.getContext('2d')!;
  ctx.drawImage(img, (img.width - side) / 2, (img.height - side) / 2, side, side, 0, 0, canvas.width, canvas.height);
  img.close();
  const blob = await new Promise<Blob | null>((ok) => canvas.toBlob(ok, 'image/jpeg', 0.9));
  if (!blob) throw new Error('Não foi possível preparar a foto.');
  return fileToBase64(blob);
}
